import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/landing/modules/landing.module').then(m => m.LandingModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./plataform/plataform.module').then(m => m.PlataformModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 80],
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
